import { round } from './round';

// The portion of an invoice that counts against an order.
// By default only positions linked to an order (orderId set) count; positions
// without an orderId are unrelated and must be ignored.
// When the template has useOrderIneffective enabled ("Order Ineffective +
// Order Effective"), the whole invoice counts, so pass includeIneffective.
// Falls back to the backend-provided summary fields when positions are not
// loaded (e.g. invoices coming from the order index endpoint).
export function getOrderEffectiveAmount(inv, includeIneffective = false) {
  if (Array.isArray(inv?.positions)) {
    return inv.positions.reduce(
      (acc, pos) => {
        if (!includeIneffective && !pos.orderId) return acc;
        const netto = round(pos.price * pos.amount) || 0;
        acc.netto += netto;
        acc.brutto += round(netto * (1 + (pos.taxRate || 0) / 100)) || 0;
        return acc;
      },
      { netto: 0, brutto: 0 },
    );
  }
  if (includeIneffective) {
    return {
      netto: round(inv?.amount || 0) || 0,
      brutto: round(inv?.bruttoAmount || 0) || 0,
    };
  }
  return {
    netto: round(inv?.orderEffectiveAmountNetto || 0) || 0,
    brutto: round(inv?.orderEffectiveAmountBrutto || 0) || 0,
  };
}
